export class CheckListActiveDeactiveDto {
    checkListId:number;
    isActive?: boolean;
    updatedUser?: string;

    constructor(checkListId:number, isActive?: boolean, updatedUser?: string) {
        this.checkListId = checkListId;
        this.isActive = isActive;
        this.updatedUser = updatedUser;
    }

}